import React from 'react';

const ShippingScreen = () => {
	return (
		<div>
			<h1> shipping</h1>
		
		</div>
	);
};

export default ShippingScreen;
